export default __webpack_public_path__ + "static/media/capture.b3ee3f93.png";